























import CanCopy from "@/components/Common/Tooltip/CanCopy.vue";
import { defineProps, withDefaults } from "@vue/runtime-dom";
interface Props {
  selectedRequisite: any;
}
const __sfc_main = {};
__sfc_main.props = {
  selectedRequisite: {
    key: "selectedRequisite",
    required: true,
    type: null
  }
};
__sfc_main.setup = (__props, __ctx) => {
  return {};
};
__sfc_main.components = Object.assign({
  CanCopy
}, __sfc_main.components);
export default __sfc_main;
